import { IPowerAndEnergyRating } from 'src/net-availability/types';
import {
  AssetNamesError,
  checkAssetNames,
} from 'src/net-availability/utils/asset-names';
import { Result } from 'src/types/result';
import { getResult } from 'src/utils/result/utils';
import { fixTo3DecimalPlaces, floorTo3DecimalPlaces } from 'src/utils/rounding';

export const getUniformPerAssetNetPowerAndEnergyRating = ({
  netPowerAndEnergyRating,
  assetNames,
}: {
  netPowerAndEnergyRating: IPowerAndEnergyRating;
  assetNames: string[];
}): Result<AssetNamesError, Map<string, IPowerAndEnergyRating>> =>
  checkAssetNames(assetNames).flatMap(() => {
    const perAssetEnergyCapacity = floorTo3DecimalPlaces(
      netPowerAndEnergyRating.energyCapacity / assetNames.length,
    );
    const perAssetMaxImportPower = floorTo3DecimalPlaces(
      netPowerAndEnergyRating.maxImportPower / assetNames.length,
    );
    const perAssetMaxExportPower = floorTo3DecimalPlaces(
      netPowerAndEnergyRating.maxExportPower / assetNames.length,
    );

    const remainingEnergyCapacityDueToDivisionPrecisionError =
      fixTo3DecimalPlaces(
        netPowerAndEnergyRating.energyCapacity -
          fixTo3DecimalPlaces(perAssetEnergyCapacity * assetNames.length),
      );
    const remainingMaxImportPowerDueToDivisionPrecisionError =
      fixTo3DecimalPlaces(
        netPowerAndEnergyRating.maxImportPower -
          fixTo3DecimalPlaces(perAssetMaxImportPower * assetNames.length),
      );
    const remainingMaxExportPowerDueToDivisionPrecisionError =
      fixTo3DecimalPlaces(
        netPowerAndEnergyRating.maxExportPower -
          fixTo3DecimalPlaces(perAssetMaxExportPower * assetNames.length),
      );

    return getResult(
      new Map(
        assetNames.map((assetName, index) => {
          const assetNetPowerAndEnergyRating: IPowerAndEnergyRating = {
            energyCapacity: fixTo3DecimalPlaces(
              perAssetEnergyCapacity +
                (index === 0
                  ? remainingEnergyCapacityDueToDivisionPrecisionError
                  : 0),
            ),
            maxImportPower: fixTo3DecimalPlaces(
              perAssetMaxImportPower +
                (index === 0
                  ? remainingMaxImportPowerDueToDivisionPrecisionError
                  : 0),
            ),
            maxExportPower: fixTo3DecimalPlaces(
              perAssetMaxExportPower +
                (index === 0
                  ? remainingMaxExportPowerDueToDivisionPrecisionError
                  : 0),
            ),
          };

          return [assetName, assetNetPowerAndEnergyRating];
        }),
      ),
    );
  });
